.form-subtitle {
  margin-top: calc(var(--spacer) * 3);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.toggle-form-subtitle {
  margin-top: 0;
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}
#password-info {
  width: calc(var(--spacer) * 30);
}

#power-user-form, #proxy-configuration-form {
  min-width: calc(var(--spacer) * 28);
}
.form-field-margin {
  margin-bottom: calc(var(--spacer) * -1);
}
.form-field-checkbox-margin {
  margin-bottom: 22px;
}

.label-mw-224 {
  --form-field-label-width: calc(var(--spacer) * 28);
  &::part(form-field-label) {
    min-width: 224px;
  }
}

.password-info {
  margin-top: calc(var(--spacer));
  max-width: calc(var(--spacer) * 30);
  width: calc(var(--spacer) * 30);
}
